var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"M-Flipper",class:[_vm.flipType, {'go': _vm.isFlipping}]},[_c('div',{staticClass:"digital front",class:_vm._textClass(_vm.frontTextFromData)}),_c('div',{staticClass:"digital back",class:_vm._textClass(_vm.backTextFromData)})])
}
var staticRenderFns = []

export { render, staticRenderFns }